import {StateCreator} from 'zustand';


/**Constants */

const defaultCampaignItem = {
    id: '',
    createdBy: '',
    name: {enUS: '', frCA: '', enCA: ''},
    createdOn: '',
    description: {enUS:'',frCA:'',enCA:''},
    logo: '',
    darkLogo: '',
    updatedBy: '',
    updatedOn: '',
    isActive: false,
    link: '',
    linkText: {enUS:'',frCA:'',enCA:''},
    targetEnterprises: "",
    targetStores: "",
    uploadedEnterprises: "",
    uploadedStores: "",
    gridEnterpriseData: [],
    gridStoresData: [],
    gridEnterpriseSerachValue: "",
    gridStoresSearchValue: "",
    targetApplications: [],
    targetWorkflows: [], 
}


/** Interfaces */

interface IEvent {
    fieldName: string;
    value: string | boolean |  {enUS?:string,frCA?:string, enCA?:string} | any[];
}


export interface ILocaleText {
    enUS?: string;
    enCA?: string;
    frCA?: string
}

export interface ICampaign {
    id?: string,
    createdBy: string;
    name: ILocaleText;
    createdOn: string;
    description: ILocaleText;
    logo: string;
    darkLogo: string;
    updatedBy: string;
    updatedOn: string;
    isActive: boolean,
    showLogo: boolean,
    link: string,
    linkText: ILocaleText;
    targetEnterprises: string,
    targetStores: string,
    uploadedEnterprises: string,
    uploadedStores: string,
    gridEnterpriseData: GridData[];
    gridStoresData: GridData[];
    gridEnterpriseSerachValue: string,
    gridStoresSearchValue: string,
    targetApplications: string[],
    targetWorkflows: string[]
}


export interface ICreateCampaignSlice {
    isCreateCampaignDialogOpen: boolean;
    setIsCreateCampaignDialogOpen: (isCreateDialogOpen: boolean) => void;
    campaignArchiveSwitch: boolean;
    setCampaignArchiveSwitch: (campaignArchiveSwitch: boolean) => void;
    updateCreateCampaignData: (event: IEvent) => void;
    campaignItems: Partial<ICampaign>;
    setCampaignItem: (campaign?: Partial<ICampaign> | null) => void,
    campaignSearchValue: string,
    setCampaignSearchValue: (searchValue: string) => void
    isPreviewCampaignDialogOpen: boolean;
    setIsPreviewCampaignDialogOpen: (isCreateDialogOpen: boolean) => void;
    showDialogToast: boolean;
    setShowDialogToast: (showDialogToast: boolean) => void;
    dialogToastContent: string;
    setDialogToastContent: (dialogToastContent: string) => void;
    isCreateOrUpdatePreview: boolean;
    setIsCreateOrUpdatePreview: (showDialogToast: boolean) => void;
    setCampaignPermission:(campaignPermission: any) => void;
    campaignPermission:any;
    campaignList: any;
    setCampaignList: (campaignList: any) => void
}

interface GridData {
    isSelected: boolean;
    name: string;
};

const _setCampaignList = (set: any) => (campaginList: any) =>
  set((state: any) => {
    return campaginList;
  });

export const createCampaignSlice: StateCreator<ICreateCampaignSlice,
    [['zustand/devtools', never]],
    [],
    ICreateCampaignSlice> = (set) => {

    return {
        isCreateCampaignDialogOpen: false,
        setIsCreateCampaignDialogOpen: (isCreateCampaignDialogOpen) => {
            return set(() => ({isCreateCampaignDialogOpen}))
        },
        campaignItems: defaultCampaignItem as unknown as ICampaign,
        campaignSearchValue: '',
        setCampaignSearchValue: (campaignSearchValue) => set((state) => ({campaignSearchValue})),
        setCampaignItem: (campaignItems) =>
            set((state) => {
                if (campaignItems?.id) {
                    return {
                        campaignItems
                    }
                }
                return {
                    campaignItems: defaultCampaignItem
                }
            }),
        updateCreateCampaignData: (event) =>
            set((state) => {
                return {
                    campaignItems: {
                        ...state.campaignItems,
                        [event.fieldName]: event.value
                    }
                }
            }),
            isPreviewCampaignDialogOpen: false,
            setIsPreviewCampaignDialogOpen: (isPreviewCampaignDialogOpen) => {
                return set(() => ({isPreviewCampaignDialogOpen}))
            },
        showDialogToast: false,
        setShowDialogToast: (showDialogToast) => {
            return set(() => ({ showDialogToast }))
        },
        dialogToastContent: "",
        setDialogToastContent: (dialogToastContent) => {
            return set(() => ({ dialogToastContent }))
        },
        isCreateOrUpdatePreview: false,
        setIsCreateOrUpdatePreview: (isCreateOrUpdatePreview) => {
            return set(() => ({ isCreateOrUpdatePreview }))
        },
        setCampaignPermission:(campaignPermission: any) => set(() => ({ campaignPermission })),
        campaignPermission:{},
        campaignArchiveSwitch: false,
        setCampaignArchiveSwitch: (campaignArchiveSwitch: boolean) => set(() => ({ campaignArchiveSwitch })),
        campaignList: [],
        setCampaignList: _setCampaignList(set)
    };
};
